import script from "./singleTask.vue?vue&type=script&setup=true&lang=js"
export * from "./singleTask.vue?vue&type=script&setup=true&lang=js"

import "./singleTask.vue?vue&type=style&index=0&id=03e6ff0f&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e6ff0f"]])

export default __exports__